import React from 'react';
import { Info, WarningCircle } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';

const VARIANT_STYLES = {
  empty: {
    shell: 'border-slate-200 bg-[#F7F9FC] text-slate-500',
    iconWrap: 'bg-white text-slate-400 ring-slate-200/80',
    title: 'text-slate-700',
    message: 'text-slate-500',
    DefaultIcon: Info,
    role: 'status',
    live: 'polite',
  },
  info: {
    shell: 'border-[var(--brand-primary,#1A428A)]/20 bg-[var(--brand-primary,#1A428A)]/[0.06] text-slate-600',
    iconWrap: 'bg-white text-[var(--brand-primary,#1A428A)] ring-[var(--brand-primary,#1A428A)]/15',
    title: 'text-[#201C35]',
    message: 'text-slate-600',
    DefaultIcon: Info,
    role: 'status',
    live: 'polite',
  },
  error: {
    shell: 'border-rose-200 bg-rose-50 text-rose-700',
    iconWrap: 'bg-white text-rose-500 ring-rose-200/80',
    title: 'text-rose-900',
    message: 'text-rose-700/90',
    DefaultIcon: WarningCircle,
    role: 'alert',
    live: 'assertive',
  },
};

export function PanelStateMessage({
  title,
  message,
  variant = 'empty',
  icon: IconProp,
  className,
}) {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.empty;
  const Icon = IconProp || styles.DefaultIcon;

  return (
    <div
      className={cn(
        'flex min-h-[160px] items-center justify-center rounded-xl border px-5 py-6 text-center',
        styles.shell,
        className
      )}
      role={styles.role}
      aria-live={styles.live}
    >
      <div className="flex max-w-[26rem] flex-col items-center gap-3">
        <div
          className={cn(
            'flex h-11 w-11 items-center justify-center rounded-full ring-1 shadow-sm',
            styles.iconWrap
          )}
        >
          <Icon size={22} weight="duotone" aria-hidden="true" />
        </div>
        <div>
          <div className={cn('text-sm font-semibold tracking-tight', styles.title)}>
            {title}
          </div>
          <div className={cn('mt-1.5 text-[13px] leading-5', styles.message)}>
            {message ||
              (variant === 'error'
                ? 'Try loading the panel again.'
                : 'No data matched the selected filters.')}
          </div>
        </div>
      </div>
    </div>
  );
}
